import React, { useContext, useEffect } from 'react';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';

import { GlobalContext } from '../../../../../../store';
import { IAdminTeamGame } from '../../../../../../store/admin/teamGames/store';

import { getEventFlightsObject } from '../../../Common/LeaderboardFilter/Utils/getEventFlightsObject';
import {
  useTeeSheetCreatorDispatch,
  useTeeSheetCreatorState
} from '../../Context/TeeSheetCreator.context';
import { TeamGroup } from '../TeamGroup/TeamGroup';

export const TeamGroups = () => {
  const { adminEvents } = useContext(GlobalContext);

  const {
    actions: {
      adminTeamGames: { get: getAdminTeamGames }
    },
    adminEvents: { current: event },
    adminTeamGames
  } = useContext(GlobalContext);

  const { clubId, eventId, roundId } = useRouteInfoState();

  const { filteredGroups } = useTeeSheetCreatorState();

  const { dispatch } = useTeeSheetCreatorDispatch();

  useEffect(() => {
    getAdminTeamGames(clubId, eventId, roundId);
  }, []);

  useEffect(() => {
    if (event) {
      dispatch({
        type: 'set',
        value: { attribute: 'flights', value: getEventFlightsObject(event) }
      });
    }
  }, [eventId, adminEvents]);

  useEffect(() => {
    const value = Object.values(adminTeamGames)
      .flat()
      .reduce(
        (acc, teamGame: IAdminTeamGame) =>
          acc.includes(teamGame.team) ? acc : [...acc, teamGame.team],
        []
      );

    dispatch({ type: 'set', value: { attribute: 'selectedTeams', value } });
  }, [adminTeamGames]);

  return (
    <>
      {filteredGroups.map(group => (
        <TeamGroup group={group} key={group.id} />
      ))}
    </>
  );
};
